import axios from './axios-auth'

const getWishlist = (offset, limit) =>
  new Promise((resolve, reject) => {
    const params = {
      offset: offset,
      limit: limit
    }
    axios({
      url: '/me/wishlist',
      method: 'GET',
      params: params
    })
      .then((resp) => {
        resolve(resp.data.items)
      })
      .catch((err) => {
        reject(err)
      })
  })

const putInWishlist = (productVersionId) =>
  new Promise((resolve, reject) => {
    const wishlistItem = {
      productVersionId: productVersionId,
    }
    axios({
      url: '/me/wishlist',
      data: wishlistItem,
      method: 'PUT'
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

const removeFromWishlist = (wishlistItemId) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/me/wishlist/' + wishlistItemId,
      method: 'DELETE'
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getWishlistSummary = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/me/wishlist/summary',
      method: 'GET'
    })
      .then((resp) => {
        const summary = {
          items: resp.data.items,
          points: resp.data.points
        }
        resolve(summary)
      })
      .catch((err) => {
        reject(err)
      })
  })

export { getWishlist, putInWishlist, removeFromWishlist, getWishlistSummary }
